import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-youtubemusic',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>YouTube Music icon</title><path d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0zm0 19.104c-3.924 0-7.104-3.18-7.104-7.104S8.076 4.896 12 4.896s7.104 3.18 7.104 7.104-3.18 7.104-7.104 7.104zm0-13.332c-3.432 0-6.228 2.796-6.228 6.228S8.568 18.228 12 18.228s6.228-2.796 6.228-6.228S15.432 5.772 12 5.772zM9.684 15.54V8.46L15.816 12l-6.132 3.54z"/></svg>`,
    styles: []
})
export class SimpleIconsYoutubemusicComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF0000';
    @Input() className: string = 'simple-icons-youtubemusic'
    constructor() {}
    ngOnInit(): void {}
}
